import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const CalendarIndex = () => import('./pages/CalendarIndex.vue');
const CalendarSettings = () => import('./pages/CalendarSettings.vue');
const AppointmentTypes = () => import('./pages/AppointmentTypes.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.CALENDAR,
  permissions: ['administrator', 'agent'],
};

const adminMeta = {
  featureFlag: FEATURE_FLAGS.CALENDAR,
  permissions: ['administrator'],
};

const calendarRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/calendar'),
      component: CalendarIndex,
      name: 'calendar_index',
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/calendar/settings'),
      component: CalendarSettings,
      name: 'calendar_settings',
      meta: adminMeta,
    },
    {
      path: frontendURL('accounts/:accountId/calendar/types'),
      component: AppointmentTypes,
      name: 'calendar_types',
      meta: adminMeta,
    },
  ],
};

export default calendarRoutes;
